/**
 * Route for `composite-fraud-score-combine-multiple-vendor-scor`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CompositeFraudScoreCombineMultipleVendorScorPage } from "../features/composite-fraud-score-combine-multiple-vendor-scor/CompositeFraudScoreCombineMultipleVendorScorPage";

export const compositeFraudScoreCombineMultipleVendorScorRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/composite-fraud-score-combine-multiple-vendor-scor",
	component: CompositeFraudScoreCombineMultipleVendorScorPage,
});

export default compositeFraudScoreCombineMultipleVendorScorRoute;
